import { CMP_SHOP_TAB_URL, CMP_SUPPORT_PHLEBOTOMY_ANCHOR, CMP_SUPPORT_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import BloodIcon from "@/images/BloodIcon";
import ChartIcon from "@/images/ChartIcon";
import HeartIcon from "@/images/HeartIcon";
import OrderTestsIcon from "@/images/OrderTestsIcon";

import DashboardPanel from "../DashboardPanel";
import DashboardPanelSections from "./DashboardPanelSections";
import { cmpHomeDashboardPanelPadding, cmpHomeDashboardPanelTitleProps } from "./dashboardLayout";

export default function OrdersPanel() {
  const { resolvedUrls } = useCmpRelatedUrl();

  const testsUrl = resolvedUrls[CMP_SHOP_TAB_URL].replace(":tab", "tests");
  const favouritesTestsUrl = `${testsUrl}?filterByFavourites=true`;
  const reportsUrl = resolvedUrls[CMP_SHOP_TAB_URL].replace(":tab", "reports");

  const sections = [
    {
      title: "Order tests",
      description: "Browse our range of tests",
      to: testsUrl,
      startIcon: <OrderTestsIcon size={40} />,
      startIconGap: 16
    },
    {
      title: "My favourites",
      description: "View your most popular tests",
      to: favouritesTestsUrl,
      leadingPlaceholderContent: <HeartIcon size={24} withCircle={false} color="#1A1A1A" />
    },
    {
      title: "Explore Clinical Reports",
      description: "Order our comprehensive patient reports",
      to: reportsUrl,
      leadingPlaceholderContent: <ChartIcon size={24} fill="#1A1A1A" />
    },
    {
      title: "Order phlebotomy",
      description: "Arrange a blood draw for your patient",
      to: {
        pathname: resolvedUrls[CMP_SUPPORT_URL],
        hash: `#${CMP_SUPPORT_PHLEBOTOMY_ANCHOR}`,
        state: { resetScroll: false }
      },
      leadingPlaceholderContent: <BloodIcon size={24} withCircle={false} color="#1A1A1A" />
    }
  ];

  return (
    <DashboardPanel
      title="Orders"
      titleProps={cmpHomeDashboardPanelTitleProps}
      padding={cmpHomeDashboardPanelPadding}
    >
      <DashboardPanelSections
        sections={sections}
        topSectionBackgroundColor="#EEE9FC"
        sectionLeadingPlaceholder={{ size: 40, gap: 16, borderRadius: 12 }}
      />
    </DashboardPanel>
  );
}
